import React from "react";
import { ListGroup, ListGroupItem } from 'reactstrap'
import { RemoveUserFromGroup } from "./actionButtons/RemoveUserFromGroup";
import { FormattedMessage } from 'react-intl';

function ListUsers(props) {
  const { users, removeUser } = props;

  if (! Array.isArray( users ) || users.length === 0) {
    return (
      <ListGroup>
        <ListGroupItem>
          <FormattedMessage id="messages.no_data"/>
        </ListGroupItem>
      </ListGroup>
    );
  }

  const renderItem = (user, index) => {
    return (
      <ListGroupItem key={index} className="user-item">
        <span
          className="user-name">{`${user.first_name} ${user.last_name} (${user.email})`}</span>
        <RemoveUserFromGroup removeUser={removeUser} user={user} showIcon={true}
                             index={index}/>
      </ListGroupItem>
    );
  }

  return (
    <ListGroup className="users-list">
      {users.map( renderItem )}
    </ListGroup>
  );
}

export { ListUsers }
